<h1 mat-dialog-title>Price configuration</h1>

<div mat-dialog-content class="mat-body-1">
  <form [formGroup]="priceForm"
        id="segment-edit-form"
        data-cy="element-segment-edit-form">

    <mat-form-field>
      <mat-label>Client Product</mat-label>
      <mat-select required [disabled]="!!existingData" id="product-id" [formControl]="clientProductControl"
                  (selectionChange)="productChangeHandler($event.value)">
        <mat-option *ngFor="let product of EditableClientProducts" [value]="product">
          <div class="option-text">
            <span>{{product}}</span>
          </div>
        </mat-option>
      </mat-select>
      <mat-error *ngIf="clientProductControl.hasError('required')">
        Client Product is empty
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <input matInput required [formControl]="clientIdControl" id="client-id" placeholder="Client ID">
      <mat-error *ngIf="clientIdControl.hasError('required')">
        Client ID is empty
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Price</mat-label>
      <input matInput required [formControl]="priceControl" id="price" type="number" step="0.01" min="0"
             class="right-align" (keypress)="priceForm.updateValueAndValidity()">
      <span matSuffix *ngIf="clientProductControl.value === DdpClientProduct.RESELLER">&nbsp;USD</span>
      <span matSuffix *ngIf="clientProductControl.value !== DdpClientProduct.RESELLER">&nbsp;EUR</span>
      <mat-error *ngIf="priceControl.hasError('required') || priceControl.hasError('min')">
        Price is invalid
      </mat-error>
    </mat-form-field>

  </form>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button [disabled]="priceForm.invalid || priceForm.untouched || unchanged "
          mat-raised-button
          color="primary"
          (click)="onConfirm()">
    {{ existingData ? 'Save Changes' : 'Add Price'}}
  </button>
</div>
